import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, { Pagination } from "swiper";
SwiperCore.use([Pagination]);

const cardData = [
  {
    title: "Secure deposits. Fewer no-shows.",
    subtitle:
      "Collect upfront payments or deposits. Reduce no-shows and late cancellations by up to 60% — keep your therapists fully booked.",
    image: "https://images.pexels.com/photos/4202325/pexels-photo-4202325.jpeg",
  },
  {
    title: "Automated reminders. Relax, we’ve got it.",
    subtitle:
      "Send personalized email reminders automatically. Confirm more bookings and help clients arrive on time, every time.",
    image: "https://images.pexels.com/photos/8450230/pexels-photo-8450230.jpeg",
  },
  {
    title: "Smart waitlist. Fill every gap.",
    subtitle:
      "Turn last-minute cancellations into new bookings. Let clients join your waitlist and auto-fill open slots effortlessly.",
    image: "https://images.pexels.com/photos/8450464/pexels-photo-8450464.jpeg",
  },
  {
    title: "Protect your bookings. Protect your income.",
    subtitle:
      "Secure card details at booking. Charge for no-shows automatically and keep your revenue stable.",
    image: "https://images.pexels.com/photos/5566050/pexels-photo-5566050.jpeg",
  },
];

const ThirdSpaMassage = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-semibold text-text mb-4">
          More happy clients.
        </h2>
        <p className="text-textGray text-lg max-w-3xl mx-auto">
          Keep your schedule full and your revenue steady. This is spa & massage
          software built to reduce cancellations and keep your business flowing.
        </p>
      </div>

      <div className="max-w-7xl mx-auto">
        <Swiper
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
        >
          {cardData.map((card, index) => (
            <SwiperSlide key={index}>
              <div
                className="bg-dry text-text rounded-3xl p-8 h-full flex flex-col justify-between shadow-xl min-h-[500px] cursor-pointer transition-all duration-300"
                onClick={() => toggleExpand(index)}
              >
                <div>
                  <h3 className="text-xl font-semibold whitespace-pre-line mb-4">
                    {card.title}
                  </h3>
                  <p
                    className={`text-sm mb-6 transition-all duration-300 ${
                      expandedCard === index ? "" : "line-clamp-3"
                    }`}
                  >
                    {card.subtitle}
                  </p>
                </div>
                <div className="w-full rounded-xl overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="object-contain mx-auto grayscale"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ThirdSpaMassage;
